module.exports = __webpack_public_path__ + "img/icon-payment-sms.6f0b906d.png";